import MapView from '../features/map/MapView';

/**
 * 全国态势（地图）页。
 *
 * 真实实现在 `features/map/MapView`：SVG 中国地图 + 项目健康光点 +
 * KPI 条 + 筛选 + 省份排行。点击光点会 setCurrentProjectId 并跳转「项目星图」。
 */
export default function MapPage() {
  return <MapView />;
}
